export const colors = {
    primary:"#4a7092",
    secondary:"#93b9da",
    orange:"orange",
    faintGray:"#ECECEC",
    white:"#fff",
    grey:'#757575',
    green:"green",
    tomato:"tomato",
    header:"#FFAEA2",
    transparent:"rgba(0,0,0,0.2)",
    transparent1:"rgba(0,0,0,0.1)"
}